export default "__VITE_ASSET__VuthFr3d__"